<template>
   <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button"/>
    </div>
    <div class="note-container" style="font-family: 'Poppins', sans-serif; overflow-y: auto;">
        <div class="create-order" style="min-width: 1200px;">
            <div class="left">
                <h3 class="order-type">Orden de Trabajo: {{ tempIdent }}
                    
                    <!-- {{ note_number }} -->

                </h3>
            </div>
            <div class="right">
                <button @click="showForm('initialData')">Datos iniciales y Cobro</button>

            </div>
        </div>

        <div v-if="currentForm === 'initialData'" style="min-width: 1200px;">
            <div class="main-data-container">
                
                <div class="client-data-container">
                    <div class="container-card">
                        <div class="title">
                            <h4>Datos del cliente</h4>
                            <img src="@/assets/client-icon.png">
                            <h4 v-if="clientDetails.is_credit_suspended" style="color: red;">ESTE CLIENTE TIENE EL CRÉDITO SUSPENDIDO</h4>
                        </div>
                        <div class="container-card-body">
                            <div class="client-container pb-1">
                                <div class="d-flex gap-2 position-relative align-items-start">
                                    <div class="form-input-group w-100">
                                        <label for="client_name">Cliente</label>
                                        <input type="text" id="client_name" v-model="client_name" @input="filterClients" @keydown.down.prevent="navigateClients(1)" @keydown.up.prevent="navigateClients(-1)" @keydown.enter.prevent="selectHighlightedClient" autocomplete="off" />
                                    </div>
                                    <div class="button-add-new-client d-flex align-items-start" v-if="!isClientSelected">
                                        <button @click="toggleNewClientForm" class="btn-submit-save" v-if="!addNewClient">Agregar nuevo cliente</button>
                                    </div>
                                </div>
                                <div class="dropdown-container">
                                    <div class="dropdown" v-if="filteredClients.length" ref="dropdownContainer" v-click-outside="closeDropdown">
                                        <li v-for="(client, index) in filteredClients" :key="client.id" :class="{ 'active': index === highlightedIndex }" @click="selectClient(client)" ref="dropdownItem">
                                            {{ client.client_ident + ' - ' + client.client_name}} <!--- {{ client.client_name }}-->
                                        </li>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="data-client" v-if="isClientSelected">
                                <table
                                    class="data-table text-end"
                                >
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Número: </span>
                                                    <span class="data-value">{{ clientDetails.client_ident }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Calle: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.street }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">C.P: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.codigoPostal }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Colonia: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.neighborhood }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Ciudad: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.city }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Ciudad: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.city }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Estado: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.state }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">RFC: </span>
                                                    <span class="data-value">{{ clientDetails.client_rfc }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Teléfono: </span>
                                                    <span class="data-value">{{ clientDetails.phone }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="data-client" v-if="addNewClient">
                                <table class="data-table">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_street">Recurrente</label>
                                                    <div>
                                                        <label class="switch">
                                                            <input type="checkbox" id="isVip" v-model="clientDetails.is_privileged">
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_street">Calle</label>
                                                    <input type="text" id="client_street" v-model="clientDetails.client_address.street" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_codigoPostal">C.P</label>
                                                    <input type="text" id="client_codigoPostal" placeholder="Ej. 64849" v-model="clientDetails.client_codigoPostal" @keypress="validatePositiveIntegerField"/>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_neighborhood">Colonia</label>
                                                    <input type="text" id="client_neighborhood" placeholder="Ej. Tecnológico" v-model="client_neighborhood" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label>Tipo</label>
                                                    <select v-model="clientDetails.client_type">
                                                        <option value='Asistencia'>Asistencia</option>
                                                        <option value='Aseguradora'>Aseguradora</option>
                                                        <option value='Cliente en general'>Cliente en general</option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <div class="form-input-group">
                                                    <label for="client_city">Ciudad</label>
                                                    <input type="text" id="client_city" placeholder="Ingrese una ciudad" v-model="client_city" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_state">Estado</label>
                                                    <select class="state-dropdown" id="client_state" v-model="client_state">
                                                        <option v-for="state in allStates" :key="state.name" :value="state.name">
                                                            {{ state.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_rfc">RFC</label>
                                                    <input type="text" id="client_rfc" placeholder="Ingrese el RFC" v-model="clientDetails.client_rfc" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="phone">Teléfono</label>
                                                    <input type="text" id="phone" v-model="clientDetails.phone" />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="buttons-for-saveClient pt-1">
                                    <button type="submit" class="btn-submit-save" @click="saveNewClient">Guardar datos del nuevo cliente</button>
                                    <button @click="cancelNewClient" class="btn-submit-cancel">Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container-card">
                        <div class="title">
                            <h4>Datos del vehículo</h4>
                            <img src="@/assets/vehicle-icon.png">
                            <label class="custom-checkbox">
                                                    Programar OT
                                                    <input type="checkbox" checked="checked" v-model="scheduleFor" :disabled="blockEdit">
                                                    <span class="checkmark"></span>
                                                </label>
                        </div>
                        <div class="container-card-body">
                            <table class="data-table">
                                <tbody>
                                    <tr>
  <td>
    <div class="form-input-group justify-content-end" v-show="scheduleFor" style="gap:8px; align-items:center;">
      <label>Fecha&nbsp;de&nbsp;programación:</label>
      <input type="datetime-local" style="max-width: 200px;" v-model="scheduledFor"/>

      <!-- NUEVO: botón para abrir modal -->
      <button type="button" class="btn-secondary" @click="openMultiScheduler">
        Programar&nbsp;múltiples
      </button>

      <!-- Indicador si hay múltiples fechas cargadas -->
      <span v-if="scheduledForList.length" class="badge-multi">
        {{ scheduledForList.length }} fechas seleccionadas
      </span>
    </div>
  </td>
</tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_brand">Marca: </label>
                                                <select class="state-dropdown" v-model="SelectedBrand" @change="FetchFilteredSubBrands" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option v-for="(brand, pk) in brands" :key="brand" :value="brand">
                                                        {{ pk }}
                                                    </option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_subbrand">Submarca: </label>
                                                <select class="state-dropdown" v-model="SelectedSubBrand" :disabled="blockEdit || subBrandLoading"
                                                :class="{ 'grayed-out': blockEdit, 'sub-brand-loading-grayed-out': subBrandLoading }">
                                                    <option v-for="(sub_brand, id) in sub_brands" :key="sub_brand" :value="sub_brand">
                                                        {{ id }}
                                                    </option>
                                                </select> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_model">Modelo: </label>
                                                <input type="text" id="vehicle_model" placeholder="Si desconoce, deje vacío. (Formato YYYY)" v-model="vehicle_model" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_plates">Placas: </label>
                                                <input type="text" id="vehicle_plates" placeholder="Ingrese las placas" v-model="vehicle_plates" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_engine_series">Serie: </label>
                                                <input type="text" id="vehicle_engine_series" placeholder="Ingrese la serie" v-model="vehicle_engine_series" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_color">Color&nbsp;1: </label>
                                                <input type="text" id="vehicle_color" placeholder="Ingrese el color" v-model="vehicle_color" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_color2">Color&nbsp;2:</label>
                                                <input type="text" id="vehicle_color2" placeholder="Ingrese el color 2" v-model="vehicle_color2" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="insurance_policy">Póliza:</label>
                                                <input type="text" id="insurance_policy" placeholder="Ingrese la póliza" v-model="insurance_policy" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_owner_name">Asegurado: </label>
                                                <input type="text" id="vehicle_owner_name" placeholder="Ingrese el nombre del asegurado" v-model="vehicle_owner_name" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="file_number">Expediente: </label>
                                                <input type="text" id="file_number" placeholder="Ingrese el expediente" v-model="file_number" :disabled="blockEdit" :class="['expediente-field', { 'grayed-out': blockEdit }]"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="sucursal">Sucursal: </label>
                                                <select class="state-dropdown" id="sucursal" v-model="sucursal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="file_number">Aprobado&nbsp;por:</label>
                                                <input type="text" id="approved_by" placeholder="Ingrese el nombre de quien aprueba" v-model="approved_by" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="expected_time">Tiempo&nbsp;estimado:</label>
                                                <input type="text" id="expected_time" placeholder="Ingrese el tiempo esperado en minutos" v-model="expected_time" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="insurance_incident">Siniestro:</label>
                                                <input type="text" id="insurance_incident" placeholder="Ingrese el siniestro" v-model="insurance_incident" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group" v-show="sendToLot">
                                                <label for="???">Lote</label>
                                                <select class="state-dropdown" type="text" id="payment_method" v-model="lot">
                                                    <option v-for="opt in $catalogs.lotes" :key="opt" :value="opt">{{ opt }}</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group" v-show="sendToLot">
                                                <label for="???">Retención</label>
                                                <select class="state-dropdown" type="text" id="payment_method" v-model="lot_retention">
                                                    <option value="A DISPOSICION DE SU DUEÑO">A DISPOSICION DE SU DUEÑO</option>
                                                    <option value="ABANDONO">ABANDONO</option>
                                                    <option value="ACCIDENTE">ACCIDENTE</option>
                                                    <option value="ATROPELLO">ATROPELLO</option>
                                                    <option value="EMBARGO">EMBARGO</option>
                                                    <option value="INFRACCIONES">INFRACCIONES</option>
                                                    <option value="INVESTIGACIONES">INVESTIGACIONES</option>
                                                    <option value="OPERATIVO AA">OPERATIVO AA</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <div class="form-input-group">
                                                <label for="lot_authority">Autoridad</label>
                                                <select class="state-dropdown" type="text" id="lot_authority" v-model="lot_authority">
                                                    <option value="">-Ninguno-</option>
                                                    <option v-for="opt in $catalogs.autoridades" :key="opt" :value="opt">{{ opt }}</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    <div class="container-card">
                        <div class="title">
                            <h4>Origen</h4>
                            <img src="@/assets/ubi-icon.png">
                        </div>
                        <div class="container-card-body">
                            <table class="data-table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div>
                                                <label class="custom-checkbox">
                                                    Servicio carretero
                                                    <input type="checkbox" id="toggleFields" v-model="showOptionalFields" :disabled="blockEdit">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="source_street">Calle&nbsp;y&nbsp;número: </label>
                                                <input type="text" id="source_street" v-model = "source_street" placeholder="Ingrese la calle y número principal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        
                                        <td>
                                            <div class="form-input-group" v-show="!showOptionalFields">
                                                <label for="source_inbtw">Entrecalles: </label>
                                                <input type="text" id="source_inbtw" v-model = "source_between_streets" placeholder="Ingrese entre que calles se encuentra" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <!-- <div class="form-input-group" v-show="!showOptionalFields">
                                                <label for="source_number">Número: </label>
                                                <input type="text" id="source_number" v-model = "source.number" placeholder="Ingrese el número" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div> -->
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group" v-show="!showOptionalFields">
                                                <label for="source_neighborhood">Colonia: </label>
                                                <input type="text" id="source_neighborhood" v-model = "source_neighborhood" placeholder="Ingrese la colonia" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="source_postal_code">C.P: </label>
                                                <input type="text" id="source_postal_code" v-model = "source_zip_code" placeholder="Ingrese el código postal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group" v-show="!showOptionalFields" style="position: relative;">
                                                <label for="source_municipality">Municipio: </label>
                                                <input type="text" id="source_municipality" v-model="source_city" @input="sourceFilterMunicipalities" placeholder="Ingrese el municipio" autocomplete="off" />
                                                <ul class="muni-dropdown" v-if="sourceFilteredMunicipalities.length" v-click-outside="closeDropdown">
                                                    <li v-for="(municipality, index) in sourceFilteredMunicipalities" :key="index" @click="sourceSelectMunicipality(municipality)">
                                                        {{ municipality }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group" v-show="!showOptionalFields">
                                                <label for="source_state">Estado: </label>
                                                <select id="source_state" v-model="source_state" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option v-for="state in allStates" :key="state.name" :value="state.name">
                                                        {{ state.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="source_lat">Latitud: </label>
                                                <input type="text" id="source_lat" v-model="source_lat" placeholder="Ingrese la latitud" :disabled="blockEdit" :class="[{ 'grayed-out': blockEdit }, {'input-error': !isSourceLatValid}]"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="source_long">Longitud: </label>
                                                <input type="text" id="source_long" v-model="source_lon" placeholder="Ingrese la longitud" :disabled="blockEdit" :class="[{ 'grayed-out': blockEdit }, {'input-error': !isSourceLonValid}]"/>
                                            </div>
                                        </td>
                                        <td>
  <div class="form-input-group">
    <label for="source_coords">Coords: </label>
    <input
      type="text"
      id="source_coords"
      v-model="source_coords_helper"
      placeholder="lat, lon"
      :disabled="blockEdit"
      :class="[{ 'grayed-out': blockEdit }]"
    />
  </div>
</td>
                                        <td>
                                            <div class="form-input-group" v-show="showOptionalFields">
                                                <label for="source_km" style="white-space: nowrap;">KM (Solo si es en carretera): </label>
                                                <input type="text" id="source_km" v-model = "source_km" placeholder="Ingrese el KM de la carretera" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <div class="form-input-group d-block text-start">
                                                <label for="source_notes">Observaciones: </label>
                                                <div class="row">
                                                    <div class="col">
                                                        <textarea id="source_notes" rows="2" v-model = "source_notes" placeholder="Ingrese información adicional" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"></textarea>
                                                    </div>
                                                    <div class="col ps-0">
                                                        <textarea id="quick_origin" rows="2" v-model = "quick_origin" placeholder="Ingrese el origen"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="container-card">
                        <div class="title">
                            <h4>Destino</h4>
                            <img src="@/assets/ubi-des-icon.png">
                        </div>
                        <div class="container-card-body">
                            <table class="data-table">
                                <tr>
                                    <td>

                                        <div>
                                            <label class="custom-checkbox">
                                                Servicio carretero
                                                <input type="checkbox" v-model="showOptionalFields1" :disabled="blockEdit">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </td>
                                    <td colspan="2">
                                        <div class="form-input-group">
                                            <label for="source_street" style="white-space: nowrap;">Calle y número: </label>
                                            <input type="text" id="source_street" v-model= "destination_street" placeholder="Ingrese la calle y número principal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                        </div>
                                    </td>
                                    
                                    <td>
                                        <div class="form-input-group" v-show="!showOptionalFields1">
                                            <label for="source_inbtw">Entrecalles: </label>
                                            <input type="text" id="source_inbtw" v-model= "destination_between_streets" placeholder="Ingrese entre que calles se encuentra" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                        </div>
                                    </td>
                                    <!-- <td>
                                        <div class="form-input-group" v-show="!showOptionalFields1">
                                            <label for="source_number">Número: </label>
                                            <input type="text" id="source_number" v-model = "destination.number" placeholder="Ingrese el número" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                        </div>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-input-group" v-show="!showOptionalFields1">
                                            <label for="source_neighborhood">Colonia: </label>
                                            <input type="text" id="source_neighborhood" v-model = "destination_neighborhood" placeholder="Ingrese la colonia" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-input-group">
                                            <label for="source_postal_code">C.P: </label>
                                            <input type="text" id="source_postal_code" v-model="destination_zip_code" placeholder="Ingrese el código postal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-input-group position-relative" v-show="!showOptionalFields">
                                            <label for="destination_municipality">Municipio: </label>
                                            <input type="text" id="destination_municipality" v-model="destination_city" @input="destinationFilterMunicipalities" placeholder="Ingrese el municipio" autocomplete="off" />
                                            <ul class="muni-dropdown" v-if="destinationFilteredMunicipalities.length" v-click-outside="closeDropdown">
                                                <li v-for="(municipality, index) in destinationFilteredMunicipalities" :key="index" @click="destinationSelectMunicipality(municipality)">
                                                    {{ municipality }}
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-input-group" v-show="!showOptionalFields1">
                                            <label for="destination_state">Estado: </label>
                                            <select id="destination_state" v-model="destination_state" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                <option v-for="state in allStates" :key="state.name" :value="state.name">
                                                    {{ state.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-input-group">
                                            <label for="source_lat">Latitud: </label>
                                            <input type="text" id="source_lat" v-model="destination_lat" placeholder="Ingrese la latitud" :disabled="blockEdit" :class="[{ 'grayed-out': blockEdit }, {'input-error': !isDestLatValid}]"/>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-input-group">
                                            <label for="source_long">Longitud: </label>
                                            <input type="text" id="source_long" v-model="destination_lon" placeholder="Ingrese la longitud" :disabled="blockEdit" :class="[{ 'grayed-out': blockEdit }, {'input-error': !isDestLonValid}]"/>
                                        </div>
                                    </td>
                                    <td>
  <div class="form-input-group">
    <label>Coords:</label>
    <input
      type="text"
      v-model="destination_coords_helper"
      placeholder="lat, lon"
      :disabled="blockEdit"
      :class="[{ 'grayed-out': blockEdit }]"
    />
  </div>
</td>
                                    <td colspan="2">
                                        <div class="form-input-group" v-show="showOptionalFields1">
                                            <label for="source_km">KM (Solo si es en carretera): </label>
                                            <input type="text" id="source_km" v-model="destination_km" placeholder="Ingrese el KM de la carretera" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                        <div class="form-input-group d-block text-start">
                                            <label for="source_notes">Observaciones: </label>
                                            <div class="row">
                                                <div class="col">
                                                    <textarea id="source_notes" rows="2" v-model="destination_notes" placeholder="Ingrese información adicional" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"></textarea>
                                                </div>
                                                <div class="col ps-0">
                                                    <textarea id="quick_destination" rows="2" v-model = "quick_destination" placeholder="Ingrese el destino"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- <div class="payment-data-container"> -->
                    
                <!-- </div> -->
                <div class="payment-data-container">

                    <div class="container-card">
                        <div class="title">
                            <h4>Costos</h4>
                            <img src="@/assets/cost-icon.png">
                        </div>
                        <div class="container-card-body">

                            <table class="data-table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="cost_by_km" style="white-space: nowrap;">Costo por kilómetro: </label>
                                                <input type="text" id="cost_by_km" placeholder="Ingrese el costo por km" v-model="cost_by_km" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="maneuvers">Maniobras: </label>
                                                <input type="text" id="maneuvers" placeholder="Ingrese las maniobras realizadas" v-model="maneuvers" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="total_kms" style="white-space: nowrap;">Total de kilómetros: </label>
                                                <input type="text" id="total_kms" placeholder="Ingrese el total de kms" v-model="total_kms" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="total_kms" style="white-space: nowrap;">Costo por tráfico: </label>
                                                <input type="text" id="cost_by_traffic" placeholder="Ingrese el costo por tráfico" v-model="cost_by_traffic" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="highway_tolls">Casetas: </label>
                                                <input type="text" id="highway_tolls" placeholder="Ingrese el número de casetas pagadas" v-model="highway_tolls" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="subtotal">Subtotal: </label>
                                                <input type="text" id="subtotal" placeholder="Ingrese el subtotal" v-model="subtotal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="iva">IVA: </label>
                                                <input type="text" id="iva" placeholder="Ingrese el iva" v-model="iva" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="retention">Retención: </label>
                                                <input type="text" id="retention" placeholder="Ingrese la retención" v-model="retention" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="total">Total: </label>
                                                <input type="text" id="total" placeholder="Ingrese el total" v-model="total" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="internal_payment_type" style="white-space: nowrap;">Tipo de pago: </label>
                                                <select class="state-dropdown" type="tel" id="internal-payment-type" v-model="internal_payment_type" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option value="80">80 - Error SAT</option>
                                                    <option value="23">23 - Pago remolque</option>
                                                    <option value="21">21 - Incobrable</option>
                                                    <option value="20">20 - Obsoleto</option>
                                                    <option value="9">9 - Transferencia bancaria</option>
                                                    <option value="8">8 - Remates</option>
                                                    <option value="7">7 - Ligada</option>
                                                    <option value="6">6 - Filial</option>
                                                    <option value="5">5 - Clave 8</option>
                                                    <option value="3">3 - Tarjeta de Crédito</option>
                                                    <option value="4">4 - Crédito</option>
                                                    <option value="2">2 - Cheque</option>
                                                    <option value="1">1 - Efectivo</option> <!--CONTADO-->
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="payment_method" style="white-space: nowrap;">Método de pago: </label>
                                                <select class="state-dropdown" id="payment_method" v-model="payment_method" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option value="PPD">PAGO EN PARCIALIDADES O DIFERIDO</option>
                                                    <option value="PUE">PAGO EN UNA EXHIBICIÓN</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="payment_type" style="white-space: nowrap;">Forma de pago (SAT): </label>
                                                <select class="state-dropdown" id="payment-type" v-model="payment_type" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option value="99" v-if="payment_method === 'PPD'">POR DEFINIR</option>
                                                    <template v-if="payment_method !== 'PPD'">
                                                        <option value="99">POR DEFINIR</option>
                                                        <option value="04">TARJETA DE CRÉDITO</option>
                                                        <option value="03">TRANSFERENCIA</option>
                                                        <option value="01">EFECTIVO</option>
                                                        <option value="28">TARJETA DE DÉBITO</option>
                                                        <option value="02">CHEQUE NOMINATIVO</option>
                                                    </template>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style="vertical-align: top;">
                                        <td>
                                            <div class="form-input-group">
                                                <label for="invoice_use">CFDI: </label>
                                                <select class="state-dropdown" id="invoice_use" v-model="invoice_use" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option value="G01">ADQUISICIÓN DE MERCANCÍAS</option>
                                                    <option value="G02">DEVOLUCIOINES, DESCUENTOS O BONIFICACIONES</option>
                                                    <option value="G03">GASTOS EN GENERAL</option>
                                                    <option value="I01">CONSTRUCCIONES</option>
                                                    <option value="I02">MOBILIARIO Y EQUIPO DE OFICINA POR INVERSIONES</option>
                                                    <option value="I03">EQUIPO DE TRANSPORTE</option>
                                                    <option value="I04">EQUIPO DE CÓMPUTO Y ACCESORIOS</option>
                                                    <option value="I05">DADOS, TROQUELES, MOLDES, MATRICES Y HERRAMENTAL</option>
                                                    <option value="I06">COMUNICACIONES TELEFÓNICAS</option>
                                                    <option value="I07">COMUNICACIONES SATELITALES</option>
                                                    <option value="I08">OTRA MAQUINARIA Y EQUIPO</option>
                                                    <option value="D01">HONORARIOS MÉDICOS, DENTALES Y GASTOS HOSPITALARIOS</option>
                                                    <option value="D02">GASTOS MÉDICOS POR INCAPACIDAD O DISCAPACIDAD</option>
                                                    <option value="D03">GASTOS FUNERALES</option>
                                                    <option value="D04">DONATIVOS</option>
                                                    <option value="D05">INTERESES REALES EFECTIVAMENTE PAGADOS POR CRÉDITOS HIPOTECARIOS</option>
                                                    <option value="D06">APORTACIONES VOLUNTARIAS AL SAR</option>
                                                    <option value="D07">PRIMAS POR SEGUROS DE GASTOS MÉDICOS</option>
                                                    <option value="D08">GASTOS DE TRANSPORTACIÓN ESCOLAR OBLIGATORIA</option>
                                                    <option value="D09">DEPÓSITOS EN CUENTAS PARA EL AHORRO </option>
                                                    <option value="D10">PAGOS POR SERVICIOS EDUCATIVOS</option>
                                                    <option value="S01">SIN EFECTOS FISCALES</option>
                                                    <option value="CP01">PAGOS</option>
                                                    <option value="CN01">NÓMINA</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td colspan="2">
                                            <div class="form-input-group d-block text-start">
                                                <label for="payment-notes" style="white-space: nowrap; margin-top: 0;">Notas del pago: </label>
                                                <textarea id="payment-notes" rows="2" placeholder="Ingrese notas del pago" v-model="payment_notes" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="form-input-group" style="margin-top: 12px; max-width: 320px;">
                        <label for="lead_source">Origen marketing: </label>
                        <select class="state-dropdown" id="lead_source" v-model="lead_source" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                            <option value="">Seleccionar origen</option>
                            <option value="Google">Google</option>
                            <option value="Facebook">Facebook</option>
                            <option value="Instagram">Instagram</option>
                            <option value="Recomendación">Recomendación</option>
                            <option value="Twitter">Twitter</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>
                </div>
            </div>
            
            
        </div>
    
</div>
    
    <button type="submit" class="btn-submit-save" @click="saveNote" :disabled="!isFormValid||saving_note" :class="{ 'grayed-out-missing-input': !isFormValid,'saving-note': saving_note}">Guardar</button>
    <button type="button" class="btn-submit-cancel" onclick="history.back()">Cancelar</button>

    <!-- MODAL MÚLTIPLES FECHAS -->
<transition name="fade">
  <div v-if="multiModalOpen" class="modal-backdrop">
    <div class="modal-panel">
      <div class="modal-header">
        <h4>Programar múltiples fechas</h4>
        <button class="modal-close" @click="closeMultiScheduler">×</button>
      </div>

      <div class="modal-body">
        <p class="muted">Agrega tantas fechas y horas como necesites. Se creará una copia de la OT por cada fecha.</p>

        <div class="dates-list">
          <div class="date-row" v-for="(d, i) in multiScheduleDates" :key="i">
            <input type="datetime-local" v-model="multiScheduleDates[i]" />
            <button type="button" class="btn-icon danger" @click="removeMultiDate(i)" v-if="multiScheduleDates.length > 1">Eliminar</button>
          </div>
        </div>

        <button type="button" class="btn-secondary" @click="addMultiDate">+ Agregar otra fecha</button>

        <p v-if="multiScheduleError" class="error">{{ multiScheduleError }}</p>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-submit-cancel" @click="closeMultiScheduler">Cancelar</button>
        <button
          type="button"
          class="btn-submit-save"
          :disabled="!isMultiListValid"
          @click="confirmMultiSchedule"
        >
          Usar estas fechas
        </button>
      </div>
    </div>
  </div>
</transition>

</template>

<style>
    #app {
        margin-top: 0 !important;
    }

.missing-required-field {
    border-color: #e06a6a !important;
    background-color: #ffe7e7 !important;
    box-shadow: 0 0 0 2px rgba(224, 106, 106, 0.2), inset 0 1px 2px rgba(127, 29, 29, 0.1);
}


.expediente-field {
    font-size: 10px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
    letter-spacing: 0;
}

</style>

<style scoped>

.logo-button {
    height: 40px;
}

.nav-bar-operations {
    height: 50px;
}

.muni-dropdown {
    position: absolute; /* Position relative to the parent container */
    top: 100%; /* Place it directly below the input field */
    left: 0; /* Align with the input field's left edge */
    z-index: 10000;
    width: 100%; /* Match the input field's width */
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    padding: 0; /* Remove any default padding */
    margin: 0; /* Remove the left margin */
}

.muni-dropdown li {
    padding: 8px 12px;
    cursor: pointer;
}

.muni-dropdown li:hover,
.muni-dropdown li.active {
    background-color: #007bff;
    color: #fff;
}
.muni-dropdown {
    position: absolute; /* Position relative to the parent container */
    top: 100%; /* Place it directly below the input field */
    left: 0; /* Align with the input field's left edge */
    z-index: 10000;
    width: 100%; /* Match the input field's width */
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    padding: 0; /* Remove any default padding */
    margin: 0; /* Remove the left margin */
}

.muni-dropdown li {
    padding: 8px 12px;
    cursor: pointer;
}

.muni-dropdown li:hover,
.muni-dropdown li.active {
    background-color: #007bff;
    color: #fff;
}

.dropdown-container {
    position: relative;
    z-index: 1050;
}

.dropdown {
    width: 100%; 
    background-color: #fff;
    border: 1px solid #f3f3f3;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(56, 56, 56, 0.2);
    max-height: 200px;
    overflow-y: auto; 
    list-style: none;
    z-index: 1050;
    position: absolute;
}
.dropdown li {
    padding: 8px 12px;
    cursor: pointer;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
}

.dropdown li:hover {
    background: #f3f3f3;
}

.dropdown li.active {
    background-color: #007bff;
    color: #fff;
}

.data-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}

.state-dropdown option, select {
    font-size: .9rem;
}

.table-footer {
    display: flex;
    flex-direction: column; /* Stack items for better responsiveness */
    width: 100%;
    height: auto;
    margin-top: 5px;
}

.table-footer table {
    width: 100%; /* Table takes full width of its container */
    border-collapse: collapse; /* Collapse borders for compact layout */
    table-layout: auto; /* Ensure the table adapts to content */
}

.table-footer th, 
.table-footer td {
    padding: 4px 8px; /* Reduced padding for a smaller height */
    text-align: left;
    border: 1px solid #ddd; /* Add borders for clarity */
    /* white-space: nowrap;  */
    line-height: 1; /* Reduce line height for a more compact look */
}

.table-footer th {
    background-color: #5388b4;
    color: white;
    font-weight: bold;
    font-size: 14px;
}

.table-footer td input, 
.table-footer td label, 
.table-footer td button {
    padding: 2px 6px; /* Reduced padding to make rows smaller */
    width: auto; /* Let inputs/buttons adapt to content */
    box-sizing: border-box;
    font-size: 0.8rem; /* Slightly smaller font size */
    line-height: .9; 
}

.table-footer button {
    margin-top: 0px; 
    padding: 2px 6px; /* Smaller padding on buttons */
}

.table-footer button:disabled {
    background-color: #d3d3d3;
    cursor: not-allowed;
}

.table-footer-edit {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 10px 0;
}

.table-footer-edit button {
    font-size: 14px;
    padding: 4px 15px !important;
    font-weight: bold;
}

@media (max-width: 768px) {

    

    .table-footer td::before {
        content: attr(data-label);
        position: absolute;
        left: 10px;
        width: calc(50% - 20px); /* Adjust width for labels */
        font-weight: bold;
        white-space: nowrap;
        line-height: .5; 
    }
}

/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 17px; 
    margin-right: 15px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 13px;
    width: 13px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(13px);
    -ms-transform: translateX(13px);
    transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 17px;
}

.slider.round:before {
    border-radius: 50%;
}
.checkbox-container {
    display: flex;
    align-items: center; /* Align items vertically */
    text-align: left; 
    font-weight: bold;
    width: 10vw;
    margin-left: 5px;
}

.form-input-group {
    display: flex;
    align-items: start;
    gap: 10px;
}

/* The container */
.custom-checkbox {
  display: block;
  position: relative;
  padding-left: 25px;
  font-size: 11px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;
}

/* Hide the browser's default checkbox */
.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.custom-checkbox .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  border-radius: 4px;
  border: 1px solid #d4d4d4;
  cursor: pointer;
}

.custom-checkbox input:disabled ~ .checkmark {
    border: 1px solid #e9e9e9;
    cursor: auto;
    background-color: white !important;
}

/* On mouse-over, add a grey background color */
.custom-checkbox:hover input ~ .checkmark {
  background-color: #f5f5f5;
}

/* When the checkbox is checked, add a blue background */
.custom-checkbox input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.custom-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.custom-checkbox .checkmark:after {
  left: 4px;
  top: 1.5px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.custom-checkbox input:disabled ~ .checkmark:after {
    border-color: #c9c9c9;
}

.data-table td {
    border: none !important;
    padding-right: 5px; 
}

.data-table td:last-child {
    padding-right: 0;
}

.data-table tr {
    background: none !important;
}

.data-table {
    border: none !important;
}

.data-main {
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    display: inline-block;
}
.data-main .data-value {
    color: #929292;
}

input[type=text], input[type=number], input[type=datetime-local], select, textarea {
        padding: 1.5px 8px;
        width: 100%;
        font-size: 11px;
        border: 1px solid #b7c3d4;
        border-radius: 5px;
        font-weight: 500;
        color: #1f2937;
        background-color: #ffffff;
        box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);
        transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
        outline: none;
        margin-bottom: 0;
}

input[type=text]:focus, input[type=number]:focus, input[type=datetime-local]:focus, select:focus, textarea:focus {
        border-color: #2f6feb;
        box-shadow: 0 0 0 2px rgba(47, 111, 235, 0.18), inset 0 1px 2px rgba(15, 23, 42, 0.06);
        background-color: #fbfdff;
}

label {
        display: block;
        font-size: 12px;
        margin-bottom: 0;
        font-weight: 600;
        color: #4b5563;
}

.form-input-group label {
    margin-top: 2px;
}

.main-data-container {
    display: grid;
    grid-template-columns: repeat(14, minmax(0, 1fr));
    gap: 12px;
}

.container-card {
        border: 1px solid #d5deea;
        border-radius: 0px;
        margin-bottom: 0px;
        border-top: none;
        background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
        box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.container-card-body {
    padding: 5px 8px;
}

.title {
        background: #d6e6fa;
        padding: 5px 15px;
        border-radius: 0;
        display: flex;
        align-items: center;
        gap: 10px;
        border-bottom: 1px solid #a9c3e4;
}

.title h4 {
        font-size: 16px;
        text-align: left;
        line-height: 20px;
        margin-bottom: 0;
        font-weight: 700;
        color: #1f3f66;
        letter-spacing: 0.2px;
}

.title img {
    width: 15px;
}


.nav-bar-operations {
    position: relative; 
}

.note-container {
    padding: 0 15px;
}

.create-order{
    display: flex;
    padding: 5px 0;
    justify-content: space-between;
}

#order_number {
    font-size: 18px;
    width: 100px;
    text-align: center;
}

.create-order h3 {
    font-size: 18px;
    font-weight: bold;
    padding-right: 10px;
}

.create-order .left {
    display: flex;
    align-items: center;
}

.create-order .right {
    display: flex;
    gap: 7px;
}

.create-order button {
    padding: 5px 15px;
    background-color: #d5171d;
    color: white;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: .3s all;
}

.create-order button:hover {
    background: black;
}

.client-data-container {
    grid-column: span 8;
}

.client-data-container .btn-submit-save {
    background-color: #2ada85; /* Color del botón de enviar */
    color: #fff; /* Color del texto del botón */
    border: none;
    padding: 2px 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 0;
}

.client-data-container .btn-submit-cancel {
    background-color: #d5171d; /* Color del botón de enviar */
    color: #fff; /* Color del texto del botón */
    border: none;
    padding: 2px 10px;
    border-radius: 6px;
    font-size: 11px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
}

.payment-data-container {
    grid-column: span 6;
}

.payment-data-container .btn-submit-save {
    border: none;
    padding: 4px 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 0;
}

.client-data-container .buttons-for-saveClient {
    display: flex;
    justify-content: end;
    gap: 6px;
}

.form-container {
    display: flex;
    justify-content: space-between;
    margin: 5px;
}

.form-section, .form-section-images{
    flex-basis: calc(33% - 10px); /* Ajuste para margen entre secciones */
    margin-right: 10px; /* Margen entre secciones */
    background: #fff; /* Fondo para cada sección del formulario */
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.1); /* Sombra suave para resaltar secciones */
}

.form-section-images img{
    width: 100px;
    height: 100px;
}

.image-container {
    margin-top: 10vh;
    width: 100%;
    height: 200px;
}

.image-container-upload {
    margin-top: 2vh;
    margin-bottom: 3vh;
    width: 100%;
    height: 200px;
}

.form-group-images{
    height: 8vh;
}

.image-container-upload img{
    width: 200px !important;
    height: 200px !important;
}


.form-section:last-child {
    margin-right: 0; /* Para que no haya margen a la derecha de la última sección */
}

h2 {
    margin-bottom: 20px; /* Espacio debajo de los títulos de sección */
}
.form-group label {
    text-align: left; /* Alinea el texto de la etiqueta a la izquierda */
    font-weight: bold; /* Hace que el texto de la etiqueta sea negrita */
    display: inline-block; /* Hace que la etiqueta sea en bloque pero alinee su contenido */
    width: 100%; /* Asegura que la etiqueta ocupe todo el ancho disponible */
}
.form-section img{
    width: 40px;
    height: 40px;
}

.map-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60vh;
    padding: 20px;
}
.map {
    width: 40vw; /* Ancho inicial para pantallas grandes */
    height: 50vh; /* Altura inicial para pantallas grandes */
}


.report-map-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60vh;
    padding: 20px;
}
.report-map {
    width: 40vw; /* Ancho inicial para pantallas grandes */
    height: 50vh; /* Altura inicial para pantallas grandes */
}

table {
  width: 100%;
  border-collapse: collapse;
}

table, th, td {
  border: 1px solid black;
}

th {
  background-color: #000000;
  color: #FFC434;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(odd) {
  background-color: #ffffff;
}

button {
    color: #ffffff;
    background-color: #FFC434;
    border: none;
    border-radius: 5px;
  /* Añadir estilos al botón si es necesario */
}
.time-data{
    display: grid;
    place-items: center;
}
.checkbox-group {
    display: flex;
    justify-content: flex-start; 
    gap: 5px; 
    font-weight: bold;
    width: 10vw;
    margin-left: 5px;   
}
.button-delete-operator{
    background-color: #ff0000;
    color: white;
    font-weight: bold;
    padding: 4px 10px !important;
    border-radius: 6px;   
}
.client-container .client-dropdown {
    position: absolute;
    z-index: 10000;
    width: 15vw; 
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    max-height: 200px;
    overflow-y: auto; 
    margin-left: 20px;
}
.form-group .client-dropdown {
    position: absolute;
    z-index: 1000;
    width: 20vw; 
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    max-height: 200px;
    overflow-y: auto; 
}
.client-dropdown div {
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.2s;
}
.client-dropdown div:hover {
    background-color: #f2f2f2;
}
.form-group select {
    width: 20vw; 
    padding: 8px; 
    margin-bottom: 10px; 
    border: 1px solid #ccc;
    border-radius: 4px; 
    background-color: white; 
    -webkit-appearance: none; 
    -moz-appearance: none; 
    appearance: none; 
    position: relative;
    background-image: url('data:image/svg+xml;utf8,<svg fill="black" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>'); 
    background-repeat: no-repeat;
    background-position: right 8px top 50%; 
    background-size: 12px; 
}
.grayed-out {
    cursor: not-allowed;
}
.grayed-out-missing-input {
    opacity: 0.5; /* You can adjust the opacity to your preference */
    cursor: not-allowed;
    position: relative; /* Ensure button's position is relative */
}
.grayed-out-missing-input::after {
    content: "Los campos: Cliente, Sucursal, Marca, Submarca, y coordenadas son obligatorios. \A     Verifique que las coordenadas no tengan comas y que el cliente y sucursal haya sido correctamente seleccionado."; /* Text to show on mouse hover */
    position: absolute;
    top: -50%; /* Center the text vertically */
    left: 50%; /* Center the text horizontally */
    transform: translate(-50%, -50%); /* Center the text both vertically and horizontally */
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    white-space: pre;
    z-index: 999;
    opacity: 0; /* Initially hide the text */
    transition: opacity 0.3s ease;
}

.grayed-out-missing-input:hover::after {
    opacity: 1; /* Show the text on hover */
}
.saving-note {
    opacity: 0.5; /* You can adjust the opacity to your preference */
    cursor: not-allowed;
    position: relative; /* Ensure button's position is relative */
}
.saving-note::after {
    content: "Espere a que se guarde la nota"; /* Text to show on mouse hover */
    position: absolute;
    top: -50%; /* Center the text vertically */
    left: 50%; /* Center the text horizontally */
    transform: translate(-50%, -50%); /* Center the text both vertically and horizontally */
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    white-space: nowrap;
    z-index: 999;
    opacity: 0; /* Initially hide the text */
    transition: opacity 0.3s ease;
}

.saving-note:hover::after {
    opacity: 1; /* Show the text on hover */
}
.text-color-for-date{
    color: rgb(21, 0, 255);
}

.action-btns {
    padding-top: 15px;
}

.action-btns button {
    padding: 5px 15px;
    font-weight: bold;
    font-size: 14px;
    border-radius: 6px;
}

.btn-submit-save-edit-assistance {
    background-color: #2ada85; 
    color: #000000; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-savebilling-edit-assistance{
    background-color: #5d5d5d; 
    color: #ffffff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-back {
    background-color: #ff7700; 
    color: #fff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-complete {
    background-color: #00eeff; 
    color: #000000; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-close {
    background-color: #ff0000; 
    color: #fff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-reOpen {
    background-color: #0000ff; 
    color: #fff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-upload-images{
    background-color: #b1d0ff; 
    color: #000000; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}

.btn-submit-download-images{
    margin-top: 2vh;
    background-color: #1d0061; 
    color: #ffffff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}

.form-section-images {
  margin-bottom: 20px;
  clear: both;
}

.form-group-images {
  padding-bottom: 40px; /* Increased padding to ensure clear separation */
}

.image-container-upload {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}

.image-wrapper {
  position: relative;
  display: inline-block;
  margin: 10px; /* Ensure separation between images */
  vertical-align: top;
}

.image-wrapper img {
  display: block;
  max-width: 100%; /* Ensure the image doesn't overflow its container */
  border: 1px solid #ddd; /* Optional: add border for better visibility */
  border-radius: 4px; /* Optional: add border radius for better aesthetics */
  padding: 5px; /* Optional: add padding for better spacing */
}

.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 50%;
  padding: 5px 10px;
  cursor: pointer;
}

.delete-button:hover {
  background-color: darkred;
}

.btn-submit-upload-images,
.btn-submit-download-images {
  display: block;
  margin-top: 10px;
}

/* Transición del modal */
.fade-enter-active, .fade-leave-active { transition: opacity .15s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, .45);
  display: grid;
  place-items: center;
  z-index: 9999;
}

.modal-panel {
  width: min(680px, 92vw);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,.25);
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f2f7fa;
  padding: 10px 14px;
}
.modal-header h4 {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.modal-close {
  background: transparent;
  border: none;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #606060;
}

.modal-body {
  padding: 12px 14px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 14px 14px;
}

.muted { color: #808080; font-size: 12px; margin-bottom: 10px; }

.dates-list { display: grid; gap: 8px; margin-bottom: 10px; }
.date-row { display: flex; gap: 8px; align-items: center; }
.date-row input[type="datetime-local"] { max-width: 260px; }

.btn-secondary {
  background: #5d5d5d;
  color: #fff;
  padding: 4px 10px;
  border-radius: 6px;
  border: none;
  font-size: 12px;
  cursor: pointer;
}

.btn-icon.danger {
  background: #d5171d;
  color: #fff;
  border: none;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}

.badge-multi {
  background: #e8f5ff;
  color: #0072c6;
  border: 1px solid #cae8ff;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
}

.error { color: #d5171d; font-size: 12px; margin-top: 6px; }

.input-error {
  border: 2px solid red !important;
  box-shadow: 0 0 6px red;
}

</style>


<script>

import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    data() {
        return {
            client_state: '',
            allStates: [
                { name: 'Aguascalientes' },
                { name: 'Baja California' },
                { name: 'Baja California Sur' },
                { name: 'Campeche' },
                { name: 'Chiapas' },
                { name: 'Chihuahua' },
                { name: 'Ciudad de México' },
                { name: 'Coahuila' },
                { name: 'Colima' },
                { name: 'Durango' },
                { name: 'Estado de México' },
                { name: 'Guanajuato' },
                { name: 'Guerrero' },
                { name: 'Hidalgo' },
                { name: 'Jalisco' },
                { name: 'Michoacán' },
                { name: 'Morelos' },
                { name: 'Nayarit' },
                { name: 'Nuevo León' },
                { name: 'Oaxaca' },
                { name: 'Puebla' },
                { name: 'Querétaro' },
                { name: 'Quintana Roo' },
                { name: 'San Luis Potosí' },
                { name: 'Sinaloa' },
                { name: 'Sonora' },
                { name: 'Tabasco' },
                { name: 'Tamaulipas' },
                { name: 'Tlaxcala' },
                { name: 'Veracruz' },
                { name: 'Yucatán' },
                { name: 'Zacatecas' }
            ],
            employeeid:'',
            client_id: null,
            filteredClientStates: [],
            filteredSourceStates: [],
            filteredDestinationStates: [],
            client_name: '',
            client_address: '',
            client_rfc: '',
            phone:'',
            is_privileged: false,
            brands: [],
            sub_brands: [],
            subBrandLoading: true,
            SelectedBrand: null,
            SelectedSubBrand: null,
            vehicle_model: '',
            vehicle_plates: '',
            vehicle_engine_series: '',
            vehicle_color: '',
            vehicle_color2: '',
            insurance_policy: '',
            vehicle_owner_name: '',
            file_number: '',
            lead_source: '',
            source_street: '',
            source_between_streets: '',
            source_neighborhood: '',
            // source_street_number: '',
            source_city: '',
            source_zip_code: '',
            source_state: '',
            source_lat: 0,
            source_lon: 0,
            source_km: 0,
            source_references: '',
            destination_street: '',
            destination_between_streets: '',
            destination_neighborhood: '',
            // destination_street_number: '',
            destination_city: '',
            destination_zip_code: '',
            destination_state: '',
            destination_lat: 0,
            destination_lon: 0,
            destination_km: 0,
            destination_references: '',
            quick_origin: '',
            quick_destination: '',
            cost_by_km: 0,
            total_kms: 0,
            maneuvers: 0,
            highway_tolls: 0,
            subtotal: 0,
            iva: 0,
            retention: 0,
            total : 0,
            // total_ovr : 0,
            payment_method : '',
            internal_payment_type: '',
            payment_type : '',
            invoice_use : '',
            payment_notes : '',
            approved_by: '',
            expected_time: 0,
            sucursal: 'ASISTENCIAS',
            cost_by_traffic: 0,
            showOptionalFields: false,
            showOptionalFields1: false,
            addNewClient: false,
            clients: [], 
            tempIdent: 0,
            filteredClients: [], 
            clientDetails: {
                "client_address": {
                    
                },
                "client_type": 'Cliente en general'

            }, 
            isClientSelected: false,
            currentForm: 'initialData',
            saving_note: false,
            applies_retention: false,
            selectedClient: null, 
            highlightedIndex: -1,
            municipalities: [
                "Monterrey", "San Nicolás de los Garza", "San Pedro Garza García",
                "Guadalupe", "Apodaca", "Escobedo", "Santa Catarina", "Juárez", "García",
                "Pesquería", "Santiago", "El Carmen", "Cadereyta"
            ],
            sourceFilteredMunicipalities: [],
            destinationFilteredMunicipalities: [],
            scheduleFor: false,
            scheduledFor: '',
            insurance_incident: '',
            lot_authority: '',
            multiModalOpen: false,
multiScheduleDates: [''],
multiScheduleError: '',
scheduledForList: [], // ← aquí guardaremos el set final de fechas (string o ISO)

        };
    },
    watch: {
        client_name(newValue) {
            if (newValue) {
                this.isClientSelected = this.clients.some(client => client.client_name === newValue);
            } else {
                this.isClientSelected = false;
            }
        },
        client_state(newValue) {
            this.filteredClientStates = this.getFilteredStates(newValue);
        },
        source_state(newValue) {
            this.filteredSourceStates = this.getFilteredStates(newValue);
        },
        destination_state(newValue) {
            this.filteredDestinationStates = this.getFilteredStates(newValue);
        },
        'cost_by_km': 'updateCalculatedCosts',
        'total_kms': 'updateCalculatedCosts',
        'cost_by_traffic': 'updateCalculatedCosts',
        'maneuvers': 'updateCalculatedCosts',
        'highway_tolls': 'updateCalculatedCosts',
    },
    computed: {
        source_coords_helper: {
    get() {
      const lat = this.normalizeCoords(this.source_lat);
      const lon = this.normalizeCoords(this.source_lon);
      return lat && lon ? `${lat}, ${lon}` : "";
    },
    set(val) {
      const parsed = this.parseCoordsStrict(val);
      if (!parsed) return;

      this.source_lat = parsed.lat;
      this.source_lon = parsed.lon;
    }
  },
    destination_coords_helper: {
    get() {
      const lat = this.normalizeCoords(this.destination_lat);
      const lon = this.normalizeCoords(this.destination_lon);
      return lat && lon ? `${lat}, ${lon}` : "";
    },
    set(val) {
      const parsed = this.parseCoordsStrict(val);
      if (!parsed) return;

      this.destination_lat = parsed.lat;
      this.destination_lon = parsed.lon;
    }
  },
        isDestLatValid() {
    const lat = parseFloat(this.destination_lat);
    return lat >= 14.0 && lat <= 32.0;
  },

  isDestLonValid() {
    const lon = parseFloat(this.destination_lon);
    return lon >= -118.0 && lon <= -86.0;
  },
  isSourceLatValid() {
    const lat = parseFloat(this.source_lat);
    return lat >= 14.0 && lat <= 32.0;
  },

  isSourceLonValid() {
    const lon = parseFloat(this.source_lon);
    return lon >= -118.0 && lon <= -86.0;
  },
        isMultiListValid() {
  // Al menos una fecha válida y sin campos vacíos
  return this.multiScheduleDates.length > 0 &&
         this.multiScheduleDates.every(d => !!d && !isNaN(new Date(d).getTime()));
},

        isFormValid() {
            /** Used to prevent the form submission until all required values are set */
            return (
                //true
                // In case more needed in the future, uncommend, as of writting only brand
                // sub brand, client, and lat lon are required 
                this.client_id !== null && this.client_id !== "" &&
                this.SelectedBrand !== null && this.SelectedBrand !== "" &&
                this.SelectedSubBrand !== null && this.SelectedSubBrand !== "" &&
                this.isClientSelected &&
                //this.vehicle_model !== "" &&
                //this.vehicle_plates !== "" &&
                //this.vehicle_engine_series !== "" &&
                //this.vehicle_color !== "" &&
                //this.insurance_policy !== "" &&
                //this.vehicle_owner_name !== "" &&
                //this.file_number !== "" &&
                //this.source_street !== "" &&
                //this.source_street_number !== "" &&
                //this.source_between_streets !== "" &&
                //this.source_neighborhood !== "" &&
                //this.source_city !== "" &&
                //this.source_zip_code !== "" &&
                //this.source_state !== "" &&
                // this.source_lat !== "" &&
                this.source_lat !== "" && /^-?\d+(\.\d+)?$/.test(this.source_lat) &&
                this.source_lon !== "" && /^-?\d+(\.\d+)?$/.test(this.source_lon) &&
                // this.source_lon !== "" &&
                //this.destination_street !== "" &&
                //this.destination_street_number !== "" &&
                //this.destination_between_streets !== "" &&
                //this.destination_neighborhood !== "" &&
                //this.destination_city !== "" &&
                //this.destination_zip_code !== "" &&
                //this.destination_state !== "" &&
                // this.destination_lat !== "" &&
                // this.destination_lon !== "" //&&
                this.destination_lat !== "" && /^-?\d+(\.\d+)?$/.test(this.destination_lat) &&
                this.destination_lon !== "" && /^-?\d+(\.\d+)?$/.test(this.destination_lon) &&
                this.sucursal !== "" &&
                !this.clientDetails.is_credit_suspended
                //this.source_references !== "" &&
                //this.destination_km !== "" &&
                //this.destination_references !== "" &&
                //this.employeeid !== ""
            );
        }
    },
    created() {
        this.fetchCurrentUser();
    },
    methods: {

        _asTrimmedString(v) {
    // converts null/undefined/number/etc -> string, then trims
    return v === null || v === undefined ? "" : String(v).trim();
  },

  normalizeCoords(val) {
    return val === null || val === undefined ? "" : String(val).trim();
  },

  parseCoordsStrict(val) {
    const s = this.normalizeCoords(val);

    // strict "lat, lon"
    const m = s.match(/^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/);
    if (!m) return null;

    const lat = Number(m[1]);
    const lon = Number(m[2]);

    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
    if (lat < -90 || lat > 90) return null;
    if (lon < -180 || lon > 180) return null;

    return { lat: m[1], lon: m[2] }; // keep strings
  },

        openMultiScheduler() {
  this.multiScheduleError = '';
  // Si ya había una lista confirmada, precárgala; si no, usa el campo single si existe
  if (this.scheduledForList.length) {
    this.multiScheduleDates = this.scheduledForList.map(d => {
      try {
        // d puede venir ya en ISO, devuélvelo a local input value
        const dt = new Date(d);
        const tz = dt.getTimezoneOffset() * 60000;
        return new Date(dt.getTime() - tz).toISOString().slice(0, 16);
      } catch {
        return d;
      }
    });
  } else if (this.scheduledFor) {
    this.multiScheduleDates = [this.scheduledFor];
  } else {
    this.multiScheduleDates = [''];
  }
  this.multiModalOpen = true;
},
closeMultiScheduler() {
  this.multiModalOpen = false;
  this.multiScheduleError = '';
},
addMultiDate() {
  this.multiScheduleDates.push('');
},
removeMultiDate(i) {
  this.multiScheduleDates.splice(i, 1);
  if (!this.multiScheduleDates.length) this.multiScheduleDates.push('');
},
confirmMultiSchedule() {
  // Validación básica: fechas válidas, no pasadas, sin duplicados
  const now = new Date();
  const parsed = [];

  for (const d of this.multiScheduleDates) {
    if (!d) {
      this.multiScheduleError = 'Hay campos de fecha vacíos.';
      return;
    }
    const dt = new Date(d);
    if (isNaN(dt.getTime())) {
      this.multiScheduleError = 'Una o más fechas no son válidas.';
      return;
    }
    if (dt.getTime() <= now.getTime()) {
      this.multiScheduleError = 'No se permiten fechas/horas pasadas.';
      return;
    }
    parsed.push(dt);
  }

  // Normaliza a ISO y elimina duplicados por milisegundo
  const uniqueSorted = Array
    .from(new Map(parsed.map(x => [x.getTime(), x])).values())
    .sort((a, b) => a - b)
    .map(dt => dt.toISOString());

  if (!uniqueSorted.length) {
    this.multiScheduleError = 'Debes capturar al menos una fecha válida.';
    return;
  }

  this.scheduledForList = uniqueSorted;
  this.multiModalOpen = false;

  // Marca visual
  Swal.fire('Fechas cargadas', `Se capturaron ${uniqueSorted.length} fecha(s).`, 'success');
},

        sourceFilterMunicipalities() {
            const searchTerm = this.source_city.toLowerCase();
            this.sourceFilteredMunicipalities = this.municipalities.filter(municipality =>
                municipality.toLowerCase().includes(searchTerm)
            );
        },
        sourceSelectMunicipality(municipality) {
            this.source_city = municipality;
            this.sourceFilteredMunicipalities = [];
        },
        destinationFilterMunicipalities() {
            const searchTerm = this.destination_city.toLowerCase();
            this.destinationFilteredMunicipalities = this.municipalities.filter(municipality =>
                municipality.toLowerCase().includes(searchTerm)
            );
        },
        destinationSelectMunicipality(municipality) {
            this.destination_city = municipality;
            this.destinationFilteredMunicipalities = [];
        },
        navigateClients(direction) {
            if (!this.filteredClients.length) return;

            const count = this.filteredClients.length;
            this.highlightedIndex = (this.highlightedIndex + direction + count) % count;

            // Scroll the highlighted item into view
            this.$nextTick(() => {
                const dropdown = this.$refs.dropdownContainer;
                const highlightedItem = this.$refs.dropdownItem[this.highlightedIndex];
                if (dropdown && highlightedItem) {
                    const itemOffsetTop = highlightedItem.offsetTop;
                    const itemHeight = highlightedItem.offsetHeight;
                    const dropdownScrollTop = dropdown.scrollTop;
                    const dropdownHeight = dropdown.offsetHeight;

                    if (itemOffsetTop < dropdownScrollTop) {
                        dropdown.scrollTop = itemOffsetTop;
                    } else if (itemOffsetTop + itemHeight > dropdownScrollTop + dropdownHeight) {
                        dropdown.scrollTop = itemOffsetTop - dropdownHeight + itemHeight;
                    }
                }
            });
        },
        selectHighlightedClient() {
            if (this.highlightedIndex !== -1) {
                this.selectClient(this.filteredClients[this.highlightedIndex]);
            }
        },
        updateCalculatedCosts() {
            this.subtotal = (
                (Number(this.cost_by_km) * Number(this.total_kms) || 0) +
                (Number(this.cost_by_traffic) || 0) +
                (Number(this.maneuvers) || 0) +
                (Number(this.highway_tolls) || 0)
            ).toFixed(2); // Ensures the result is a string formatted to two decimal places
            this.iva = (
                (this.subtotal) * .16
            ).toFixed(2);
            this.retention = (
                (this.subtotal) * (this.applies_retention ? .04 : 0)
            ).toFixed(2);
            this.total = (
                Number(this.subtotal) + Number(this.iva) - Number(this.retention)
            ).toFixed(2);
        },
        fetchCurrentUser() {
            const apiDirectory = process.env.API_DIRECTORY;
            axios.get(`${apiDirectory}/current-user/`, {
                headers: {
        'Authorization': 'Token ' + localStorage.getItem('authToken')
        }
            })
            .then(response => {
                this.employeeid = response.data.employee_id; 
            })
            .catch(error => {
                console.error('There was an error fetching the user data:', error);
            });
            },
        async fetchClients() {
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.get(`${apiDirectory}/get-privileged-clients`);
                this.clients = response.data;
            } catch (error) {
                // error
            }
        },
        filterClients() {
            const searchTerm = this.client_name.toLowerCase().trim();

            if (searchTerm === '') {
                this.filteredClients = [];
                this.highlightedIndex = -1;
                return;
            }

            this.filteredClients = this.clients.filter(client => {
                return (
                    client.client_name.toLowerCase().includes(searchTerm) ||
                    client.client_ident.toLowerCase().includes(searchTerm)
                );
            });

            this.highlightedIndex = -1;
        },
        selectClient(client) {
            this.clientDetails = { ...client };
            this.client_name = client.client_name;
            this.client_id = client.id;
            this.filteredClients = [];
            this.isClientSelected = true;
            this.is_privileged = client.is_privileged;
            this.applies_retention = false;
            this.highlightedIndex = -1;
            if (client.applies_retention) {
                    this.applies_retention = client.applies_retention;
            }
            this.payment_method = client.client_payment_method;
            this.internal_payment_type = client.client_internal_payment_type;
            this.payment_type = client.client_payment_type;
            this.invoice_use = client.client_invoice_use   
        },
        toggleNewClientForm(){
            this.addNewClient = true;
            if (this.addNewClient) {
                this.isClientSelected = false;
            }
        },
        cancelNewClient() {
            this.addNewClient = false; 
        },
        closeDropdown() {
            this.filteredClients = [];
            this.sourceFilteredMunicipalities = [];
            this.destinationFilteredMunicipalities = [];
        },
        filterStates() {
            if (!this.searchState) {
            this.filteredStates = this.states;
            } else {
            this.filteredStates = this.states.filter((state) =>
                state.toLowerCase().includes(this.searchState.toLowerCase())
            );
            }
            this.isStateDropdownActive = true;
        },
        getFilteredStates(searchValue) {
            if (searchValue.length < 0) {
                return [];
            }
            return this.allStates.filter(state =>
                state.name.toLowerCase().includes(searchValue.toLowerCase())
            );
        },
        selectClientState(name) {
            this.client_state = name;
            this.filteredClientStates = []; 
        },
        selectSourceState(name){
            this.source_state = name;
            this.filteredSourceStates = [];
        },
        selectDestinationState(name){
            this.destination_state = name;
            this.filteredDestinationStates = [];
        },
        showPopUp() {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Captura los datos iniciales para poder continuar',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Entendido'
            });
        },
        backMainPanel() {
            this.$router.push('/main-panel');
        },
        showForm(formName) {
            this.currentForm = formName;
        },
        async getTempIdent() {
            const apiDirectory = process.env.API_DIRECTORY;
            const numberResponse = await axios.post(`${apiDirectory}/calculate-note-number`);
            const noteNumber = numberResponse.data;
            this.tempIdent = noteNumber
        },

        async saveNote() {
  if (this.saving_note) {
    return;
  }
  try {
    this.sanitizeForm();
    this.saving_note = true;
    const apiDirectory = process.env.API_DIRECTORY;

    // Common payload (both immediate and scheduled)
    const baseData = {
      // identifiers only added for immediate notes
      type: 2,
      client: this.client_id,
      request_time: new Date().toISOString(),
      vehicle_brand: this.SelectedBrand,            // kept as in your current code
      vehicle_sub_brand: this.SelectedSubBrand,
      vehicle_model: this.vehicle_model,
      vehicle_plates: this.vehicle_plates,
      vehicle_engine_series: this.vehicle_engine_series,
      vehicle_color: this.vehicle_color,
      vehicle_color2: this.vehicle_color2,
      insurance_policy: this.insurance_policy,
      vehicle_owner_name: this.vehicle_owner_name,
      file_number: this.file_number,
      lead_source: this.lead_source,
      source: {
        street_name: this.source_street,
        between_streets: this.source_between_streets,
        neighborhood: this.source_neighborhood,
        city: this.source_city,
        zip_code: this.source_zip_code,
        state: this.source_state,
        lat: this.source_lat,
        lon: this.source_lon,
      },
      source_km: this.source_km,
      source_notes: this.source_notes,
      destination: {
        street_name: this.destination_street,
        between_streets: this.destination_between_streets,
        neighborhood: this.destination_neighborhood,
        city: this.destination_city,
        zip_code: this.destination_zip_code,
        state: this.destination_state,
        lat: this.destination_lat,
        lon: this.destination_lon,
      },
      destination_km: this.destination_km,
      destination_notes: this.destination_notes,
      data_entry_clerk: this.employeeid,
      cost_by_km: this.cost_by_km,
      total_kms: this.total_kms,
      maneuvers: this.maneuvers,
      highway_tolls: this.highway_tolls,
      subtotal: this.subtotal,
      iva: this.iva,
      retention: this.retention,
      total: this.total,
      total_ovr: this.total_ovr,
      payment_method: this.payment_method,
      internal_payment_type: this.internal_payment_type,
      payment_type: this.payment_type,
      invoice_use: this.invoice_use,
      payment_notes: this.payment_notes,
      vehicle_inventory: {
        extinguidor: false,
        cablesPasaCorriente: false,
        llaveBirloSeguridad: false,
        llaveRuedas: false,
        senalesCarretera: false,
        tarjetaCirculacion: false,
        permisoImportacion: false,
        llaves: false,
        llavero: false,
        control: false,
        antena: false,
        canastilla: false,
        emblemas: false,
        espoilersDelantero: false,
        espoilersTrasero: false,
        taponesRuedas: false,
        taponGasolina: false,
        tapaArmellaEnganche: false,
        portaPlacas: false,
        placasDelanteras: false,
        placasTrasera: false,
        toldo: false,
        quemacocos: false,
        marcaBateria: "",
        marcaRadio: "",
        numeroBocinas: "",
        numeroHerramientas: "",
        tipoGato: "",
        marcaLlantaRefaccion: "",
        rines: "",
        marcaLlantasVehiculo: "",
        vidaLlantasdelanteraIzq: "",
        vidaLlantasdelanteraDer: "",
        vidaLlantastraseraIzq: "",
        vidaLlantastraseraDer: "",
      },
      status: 3,
      approved_by: this.approved_by,
      expected_time: this.expected_time,
      sucursal: this.sucursal,
      cost_by_traffic: this.cost_by_traffic,
      quick_destination: this.quick_destination,
      quick_origin: this.quick_origin,
      insurance_incident: this.insurance_incident,
      lot_authority: this.lot_authority
    };

    // ---- SCHEDULED PATH ----
if (this.scheduleFor) {
  const hasMulti = this.scheduledForList && this.scheduledForList.length > 0;

  if (!hasMulti && !this.scheduledFor) {
    this.saving_note = false;
    await Swal.fire('Falta la fecha/hora', 'Selecciona la fecha y hora de programación o usa "Programar múltiples".', 'warning');
    return;
  }

  // Construye la lista final de fechas a programar
  const dateList = hasMulti
    ? this.scheduledForList           // ya vienen en ISO
    : [new Date(this.scheduledFor).toISOString()];

  const scheduledResults = { ok: 0, fail: 0, errors: [] };

  for (const whenISO of dateList) {
    const scheduledPayload = {
      ...baseData,
      scheduled_for: whenISO,
    };

    try {
      await axios.post(`${apiDirectory}/create-scheduled-note/`, scheduledPayload, {
        headers: { 'Content-Type': 'application/json' },
      });
      scheduledResults.ok += 1;
    } catch (e) {
      scheduledResults.fail += 1;
      scheduledResults.errors.push(whenISO);
    }
  }

  if (scheduledResults.fail === 0) {
    await Swal.fire('¡Programado!', `Se programaron ${scheduledResults.ok} nota(s) correctamente.`, 'success');
  } else if (scheduledResults.ok > 0) {
    await Swal.fire(
      'Programación parcial',
      `Exitosas: ${scheduledResults.ok} • Fallidas: ${scheduledResults.fail}<br><small>${scheduledResults.errors.join('<br>')}</small>`,
      'warning'
    );
  } else {
    await Swal.fire('Error', 'No se pudo programar ninguna fecha.', 'error');
  }

  // Limpia por si el usuario se queda en la pantalla
  this.scheduledForList = [];
  this.scheduledFor = '';
  this.$router.push({ name: 'OperationsModule' });
  return;
}


    // ---- IMMEDIATE PATH (current behavior) ----
    const identifierResponse = await axios.post(`${apiDirectory}/create-identifier`, { note_type: 2 });
    const numberResponse = await axios.post(`${apiDirectory}/calculate-note-number`);
    const noteIdent = identifierResponse.data.identifier;
    const noteNumber = numberResponse.data;

    const quoteData = {
      ...baseData,
      note_ident: noteIdent,
      note_number: noteNumber,
    };

    const createResponse = await axios.post(`${apiDirectory}/create-service-note`, quoteData, {
      headers: { 'Content-Type': 'application/json' },
    });
    const savedNoteNumber = createResponse?.data?.note_number ?? noteNumber;

    if (this.tempIdent != savedNoteNumber) {
      await Swal.fire({
        title: 'Atención',
        html: `El número <b>${this.tempIdent}</b> ya fue ocupado.<br>La nueva nota se guardó con el siguiente número: <b>${savedNoteNumber}</b>`,
        icon: 'warning',
        confirmButtonText: 'Aceptar',
      });
    } else {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            background: "#d4edda",
            title: "¡Guardado!",
            text: 'Los datos del formulario se han guardado con éxito.',
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            // didClose: () => {
            // window.location.reload();
            // }
        });
    //   await Swal.fire('¡Guardado!', 'Los datos del formulario se han guardado con éxito.', 'success');
    }

    this.$router.push({ name: 'OperationsModule' });

  } catch (error) {
    console.error(error);
    // Polygon condition and bad serializer cases
    if (error?.response?.status === 400) {
      let isPolygon = false;
      if (error.response.data) {
        const errorDataString = JSON.stringify(error.response.data);
        try { isPolygon = errorDataString.includes("area"); } catch { isPolygon = false; }
      }
      if (isPolygon) {
        Swal.fire('Error', 'Verifique que la latitud y longitud sean válidas. \nLos datos que intentó ingresar no corresponden a una dirección dentro de México.', 'error');
      } else {
        Swal.fire('Error', 'Verifique que los datos que está ingresando son válidos', 'error');
      }
    } else {
      Swal.fire('Error', 'Hubo un problema al actualizar los datos de la nota.', 'error');
    }
  } finally {
    this.saving_note = false;
  }
},


        async saveNewClient() {
            const clientData = {
                client_ident: 'test',
                client_name: this.client_name,
                client_address: {
                    street: this.clientDetails.client_address.street,
                    codigoPostal: this.clientDetails.client_codigoPostal,
                    neighborhood: this.client_neighborhood,
                    city: this.client_city,
                    state: this.client_state,
                },
                client_rfc: this.clientDetails.client_rfc,
                phone: this.clientDetails.phone,
                client_status: 1,
                is_privileged: this.clientDetails.is_privileged,
                client_type: this.clientDetails.client_type
                
            };

            try {
                // Validate clientData here (optional)

                // Replace 'http://yourbackend.api/clients' with your actual API endpoint
                console.log(clientData);
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.post(`${apiDirectory}/create-client`, clientData, {
                            headers:
                            {
                                'Content-Type': 'application/json',
                            },
                        });
                this.client_id = response.data.id;
                this.isClientSelected = true
                this.addNewClient = false
                
                // If the request is successful
                Swal.fire('Guardado!', 'El nuevo cliente se guardó correctamente.', 'success');
                

            } catch (error) {
                console.error('There was an error saving the client:', error);
                Swal.fire('Error', 'Hubo un problema al guardar el cliente nuevo.', 'error');
            }
        },
        async FetchBrands() {
            /** Fetches the brands from the db an passes it to the brands prop */
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.get(`${apiDirectory}/get-brands`);
                // Tmp dict to hold the response after processing 
                const brandsDict = {};
                // Convert response into dict of form: {pk:brand}
                response.data.forEach(brand => {
                    //brandsDict[brand.pk] = brand.brand;  // Adjust based on actual keys in your data
                    brandsDict[brand.brand] = brand.pk;  // Adjust based on actual keys in your data
                });
                console.log(brandsDict)
                this.brands = brandsDict
            }
            catch (error) {
                console.error("Failed to fetch brands", error);
                console.log(error.response)
                if (error.response.status == 400) {
                    Swal.fire('Error', "Hubo un problema con la solicitud. Intentalo nuevamente.\n\
                    Si el problema persiste, contacte a su administrador.", 'error');
                    return
                }
                if (error.response.status == 500) {
                    Swal.fire('Error', "Ocurrió un error desconocido. Intentalo nuevamente.\n\
                    Si el problema persiste, contacte a su administrador.", 'error');
                }
            }
        },
        async FetchFilteredSubBrands(event){
            // Grab the value from the brand selector 
            this.subBrandLoading = true

            const selectedBrandPk = event.target.value;
            // Checks if there was a change in the brand. If so, reset the vue model value to null to prevent form submission until a conscius selection is made
            selectedBrandPk !== this.SelectedBrand ?  this.SelectedSubBrand = null : true;
            try { 
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.post(`${apiDirectory}/get-filtered-sub-brands`,{"brand_id":selectedBrandPk});
                // Tmp dict to hold the response after processing 
                const subBrandsDict = {};
                // Convert response into dict of form: {id:sub_brand + "Clase: "+ required_class}
                const classes={1:'A',2:'B',3:'C',4:'D'}
                response.data.forEach(sub_brand => {
                    subBrandsDict[sub_brand.sub_brand+' '+'-- Clase: '+classes[sub_brand.required_unit_type]] = sub_brand.id;  // Adjust based on actual keys in your data
                });
                this.sub_brands = subBrandsDict;
                this.subBrandLoading = false
            }
            catch (error) {
                console.error("Failed to fetch brands", error);
                console.log(error.response)
                if (error.response.status == 400) {
                    Swal.fire('Error', "Hubo un problema con la solicitud. Intentalo nuevamente. \
                    Si el problema persiste, contacte a su administrador.", 'error');

                }
                if (error.response.status == 500) {
                    Swal.fire('Error', "Ocurrió un error desconocido. Intentalo nuevamente. \
                    Si el problema persiste, contacte a su administrador.", 'error');
                }
            }
        },
        validatePositiveIntegerField(event) {
            /**Used to validate positive integer fields */
            if (event.charCode < 48 || event.charCode > 57) {
                event.preventDefault();
            }
        },
        validateFloatField(event) {
            const charCode = event.charCode;
            const value = event.target.value;

            const isDigit = charCode >= 48 && charCode <= 57;
            const isMinus = charCode === 45 && value.indexOf('-') === -1;
            const isDot = charCode === 46 && value.indexOf('.') === -1;

            if (!isDigit && !isMinus && !isDot) {
                event.preventDefault();
            }
        },
        sanitizeForm() {
            /**Used to sanitize values before submitting any changes */

            //Since not all notes require km, change empty str to null
            this.source_km == "" ? this.source_km = null : true
            this.destination_km == "" ? this.destination_km = null : true
            this.vehicle_model == "" ? this.vehicle_model = null : true
        },
    },
    mounted() {
        this.fetchClients();
        this.FetchBrands();
        this.getTempIdent();
        // Any initializations you might want when the component is mounted
    },
}
</script>